import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Input, isDark, brightenColor, darkenColor,
} from '@twnel/web-components';

const StyledLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme?.actionable ?? '#415161'};
  font-weight: 500;
  @media (hover: hover) {
    transition: opacity 0.2s ease-out;
    &:hover, &:active {
      opacity: 0.8;
    }
  }
`;

StyledLink.propTypes = {
  theme: PropTypes.shape({
    actionable: PropTypes.string.isRequired,
  }),
};

const InputField = styled.div`
  ${({ $mobile = false }) => ($mobile ? '' : `
    display: flex;
    align-items: center;
  `)}
  position: relative;
  margin: 10px 0;
  & > *:last-child {
    color: ${({ theme }) => theme?.error ?? '#C84D59'};
    font-weight: 500;
    ${({ $mobile = false }) => ($mobile ? `
      margin: 10px 0 25px 5px;
    ` : `
      position: absolute;
      right: -10px;
      transform: translate(100%, 0);
    `)}
  }
`;

InputField.propTypes = {
  $mobile: PropTypes.bool,
  theme: PropTypes.shape({
    error: PropTypes.string.isRequired,
  }),
};

const AvatarInput = styled(Input)`
  height: 260px;
  margin: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: ${({ theme }) => theme?.input?.background ?? '#FFFFFF'};
  background-image: ${({ theme }) => {
    const bg = theme?.input?.background ?? '#FFFFFF';
    // brightenColor/darkenColor take (shade: 0-10, color) — a low shade keeps the
    // checkerboard stripes subtle against the background.
    const color = (isDark(bg) ? brightenColor : darkenColor)(2, bg);
    return `
      linear-gradient(45deg, ${color} 25%, transparent 25%, transparent 75%, ${color} 75%, ${color}),
      linear-gradient(45deg, ${color} 25%, transparent 25%, transparent 75%, ${color} 75%, ${color});
    `;
  }};
  background-size: 24px 24px;
  background-position: 0 0, 12px 12px;
`;

AvatarInput.propTypes = {
  theme: PropTypes.shape({
    input: PropTypes.shape({
      background: PropTypes.string.isRequired,
      foreground: PropTypes.string.isRequired,
    }),
  }),
};

export {
  StyledLink,
  InputField,
  AvatarInput,
};
